<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.nameCampaign') }} </label>
                    <div class="col-sm-10">
                        {{ dataForm?.campaign?.name ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.detailFirstView') }} </label>
                    <div class="col-sm-10">
                        <b-img
                            v-if="dataForm.first_view.image?.path && arrExtension.includes(dataForm.first_view.image.extension)"
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.first_view.image?.path"
                            :alt="dataForm.first_view.image.origin_name"
                            rounded
                            style="width: 500px; object-fit: cover; object-position: center"
                        ></b-img>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingFirstView.finishedFirstView') }} </label>
                    <div class="col-sm-10">
                        <b-img
                            v-if="dataForm.first_view.finished_image?.path && arrExtension.includes(dataForm.first_view.finished_image.extension)"
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.first_view.finished_image?.path"
                            :alt="dataForm.first_view.finished_image.origin_name"
                            rounded
                            style="width: 500px; object-fit: cover; object-position: center"
                        ></b-img>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { renderLineBreaks, IMAGE_EXTENSIONS } from '@/utils/format';

export default {
    name: 'SettingFirstViewAndTimeApplication',
    components: {},
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            arrExtension: IMAGE_EXTENSIONS
        };
    },
    methods: {
        textLineBreaks(text) {
            return renderLineBreaks(text);
        }
    }
};
</script>

<style lang="scss" scoped></style>
